export default {
  alert: {
    title: 'Information',
    ok: 'Ok',
  },
  confirm: {
    title: 'Confirm',
    ok: 'Ok',
    cancel: 'Cancel',
  },
};
